import { useScopedI18n, useCurrentLocale } from '@/locales/client'
import { SubNavItem } from '@tameeni/ui'
import { useLocation } from 'react-router-dom'
import { getBaseUrl } from '../utils/url-helpers'

export function useHeader(isAuthenticated = false) {
  const t = useScopedI18n('common.header')
  const l = useScopedI18n('common.links')
  const locale = useCurrentLocale()
  const location = useLocation()
  const pathname = location.pathname
  const isDashboard = pathname.includes('/dashboard')

  const sideNavItems = [
    {
      label: t('products'),
      items: [
        {
          icon: 'MotorColored',
          label: l('carInsurance'),
          link: getBaseUrl('', locale),
        },
        {
          icon: 'HealthColored',
          label: l('healthInsurance'),
          link: '',
          subItems: (
            <div className='mx-auto flex w-full max-w-7xl flex-col gap-6'>
              <div>
                <h3 className='mb-4 text-sm font-medium text-slate-500'>
                  {l('forBusiness')}
                </h3>
                <SubNavItem
                  description={l('smeDescription')}
                  icon='HealthSme'
                  label={l('smeHealth')}
                  arrowClassName={`${locale === 'ar' ? 'rotate-180' : ''}`}
                  link={getBaseUrl('/health-sme', locale)}
                />
              </div>
              <div>
                <h3 className='mb-4 text-sm font-medium text-slate-500'>
                  {l('forIndividual')}
                </h3>
                <div className='space-y-2'>
                  <SubNavItem
                    description={l('premiumResidencyDescription')}
                    icon='HealthColored'
                    label={l('premiumResidency')}
                    arrowClassName={`${locale === 'ar' ? 'rotate-180' : ''}`}
                    link={getBaseUrl('/health-pr', locale)}
                  />
                  <SubNavItem
                    description={l('domesticHelperDescription')}
                    icon='DomesticHelper'
                    label={l('domesticHelper')}
                    arrowClassName={`${locale === 'ar' ? 'rotate-180' : ''}`}
                    link={getBaseUrl('/health', locale)}
                  />
                </div>
              </div>
            </div>
          ),
        },
        {
          icon: 'MMPColored',
          label: l('medicalMalpractice'),
          link: getBaseUrl('/mmp', locale),
          isActive: true,
        },
        {
          icon: 'TravelColored',
          label: l('travel'),
          link: getBaseUrl('/travel', locale),
        },
        {
          icon: 'FleetColored',
          label: l('fleet'),
          link: getBaseUrl('/fleet', locale),
        },
      ],
    },
    {
      label: t('support'),
      items: [
        {
          icon: 'LinkArrow',
          label: l('contactUs'),
          link: getBaseUrl('/contact-us', locale),
          iconClassName: locale === 'ar' ? 'rotate-180' : '',
        },
        {
          icon: 'LinkArrow',
          label: l('privacyPolicy'),
          link: getBaseUrl('/privacy-policy', locale),
          iconClassName: locale === 'ar' ? 'rotate-180' : '',
        },
        {
          icon: 'LinkArrow',
          label: l('termsAndConditions'),
          link: getBaseUrl('/terms-and-conditions', locale),
          iconClassName: locale === 'ar' ? 'rotate-180' : '',
        },
        {
          icon: 'LinkArrow',
          label: l('helpCenter'),
          link: 'https://api.whatsapp.com/send?phone=9668002444455',
          iconClassName: locale === 'ar' ? 'rotate-180' : '',
        },
        ...(isAuthenticated
          ? [
              {
                icon: 'LinkArrow' as const,
                label: t('myDashboard'),
                link: `/${locale}/dashboard`,
                iconClassName: locale === 'ar' ? 'rotate-180' : '',
                isActive: isDashboard,
              },
            ]
          : []),
      ],
    },
    {
      label: t('resources'),
      items: [
        {
          icon: 'LinkArrow',
          label: l('faq'),
          link: `/${locale}/faq`,
          iconClassName: locale === 'ar' ? 'rotate-180' : '',
        },
      ],
    },
  ]

  const socialLinks = [
    {
      icon: 'Facebook',
      label: l('facebook'),
      url: 'https://www.facebook.com/Tameeniksa/',
    },
    {
      icon: 'XLogo',
      label: l('x'),
      url: 'https://twitter.com/TameeniKSA',
    },
    {
      icon: 'Instagram',
      label: l('instagram'),
      url: 'https://www.instagram.com/tameeniksa/',
    },
    {
      icon: 'YouTube',
      label: l('youtube'),
      url: 'https://www.youtube.com/channel/UCRLnHZkwAWJW0UN5CvA6Xsg/',
    },
    {
      icon: 'Snapchat',
      label: l('snapchat'),
      url: 'https://www.snapchat.com/add/tameeniksa',
    },
    {
      icon: 'Whatsapp',
      label: l('whatsapp'),
      url: 'https://api.whatsapp.com/send?phone=9668002444455',
    },
  ]

  return {
    sideNavItems,
    socialLinks,
  }
}
